import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/nixel.gif")